/**
 * RelatedProductDialog Component
 */
(function () {

    'use strict';

    /**
     * Render RelatedProductDialog
     * @name relatedProductDialogCtrl
     * @type ItxRelatedProductDialogCmpCtrl
     */
    var ItxRelatedProductDialogCmp = {
        bindings: {
            product: '<',
            customized: '<'
        },
        controller: ItxRelatedProductDialogCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'ItxRelatedProductDialog.html'
    };

    /** Public */
    angular.module('itxApp.common')
        .component('itxRelatedProductDialog', ItxRelatedProductDialogCmp);

    ItxRelatedProductDialogCmpCtrl.$inject = [
        '$window',
        'ngDialog',
        'imPopupService'
    ];

    function ItxRelatedProductDialogCmpCtrl(
        $window, 
        ngDialog,
        imPopupService
    ) {

        var _this = this;

        _this.$onInit = function () {
            imPopupService.sendRelatedPopup(_this.product);
        };

        _this.goToShoppingCart = function () {
            if(inditex.iPage == 'ItxShopCartPage'){
                _this.closeModal();
            } else {
                $window.location.href = joyr.utils.getCommonPageUrl('ItxShopCartPage', false, false);
            }
        };

        _this.closeModal = function() {
            ngDialog.close();
        };

    }

})();
